<!-- Um único popup de menu com model dinâmico para as ações da fatura (Padrão Efetivos) -->
<p-menu #actionsMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

<div class="financeiro_page">
  <!-- ── PAGE HEADER ─────────────────────────────────────────── -->
  <div class="page_header">
    <div class="page_header_text">
      <h1>Facturação</h1>
      <span>Gestão de facturação electrónica e documentos fiscais AGT</span>
    </div>

    <div class="page_header_actions">
      <button type="button" class="btn-web-secondary" (click)="exportarRelatorio()">
        <i class="fas fa-file-export"></i> Exportar Relatório
      </button>

      <button type="button" class="btn-web-secondary" (click)="abrirDrawerNovo()">
        <i class="fas fa-bolt"></i> Emissão Rápida
      </button>

      <button type="button" class="btn-web-primary" (click)="abrirWizardNovo()">
        <i class="fas fa-plus"></i> Emitir Nova Factura
      </button>
    </div>
  </div>

  <!-- ── KPI GRID MINI (Padrão SecurPro) ─────────────────────── -->
  <div class="kpi-grid mini">
    <div class="kpi-card mini">
      <div class="kpi-icon blue">
        <i class="fas fa-money-bill-wave"></i>
      </div>
      <div class="kpi-info">
        <span>Total Facturado</span>
        <strong>{{ totalFaturadoGeral | number: '1.2-2' }} Kz</strong>
      </div>
    </div>

    <div class="kpi-card mini">
      <div class="kpi-icon yellow">
        <i class="fas fa-clock"></i>
      </div>
      <div class="kpi-info">
        <span>Pendentes AGT</span>
        <strong>{{ countSubmetidas + countRascunhos }} facturas</strong>
      </div>
    </div>

    <div class="kpi-card mini">
      <div class="kpi-icon green">
        <i class="fas fa-shield-check"></i>
      </div>
      <div class="kpi-info">
        <span>Aceites AGT</span>
        <strong class="green">{{ countAceites }} facturas</strong>
      </div>
    </div>

    <div class="kpi-card mini">
      <div class="kpi-icon red">
        <i class="fas fa-triangle-exclamation"></i>
      </div>
      <div class="kpi-info">
        <span>Rejeitadas</span>
        <strong class="red">{{ countRejeitadas }} facturas</strong>
      </div>
    </div>
  </div>

  <!-- ── FILTER CHIPS ROW (Padrão SecurPro) ──────────────────── -->
  <div class="filter-chips-row">
    <button type="button" class="filter-chip" [class.active]="activeTab === 'todas'" (click)="setTab('todas')">
      Todas ({{ countTodas }})
    </button>
    <button type="button" class="filter-chip" [class.active]="activeTab === 'rascunhos'" (click)="setTab('rascunhos')">
      Rascunhos ({{ countRascunhos }})
    </button>
    <button type="button" class="filter-chip" [class.active]="activeTab === 'submetidas'"
      (click)="setTab('submetidas')">
      Submetidas ({{ countSubmetidas }})
    </button>
    <button type="button" class="filter-chip" [class.active]="activeTab === 'aceites'" (click)="setTab('aceites')">
      Aceites ({{ countAceites }})
    </button>
    <button type="button" class="filter-chip green-chip" [class.active]="activeTab === 'pagas'"
      (click)="setTab('pagas')">
      Pagas ({{ countPagas }})
    </button>
    <button type="button" class="filter-chip red-chip" [class.active]="activeTab === 'rejeitadas'"
      (click)="setTab('rejeitadas')">
      Rejeitadas ({{ countRejeitadas }})
    </button>
  </div>

  <!-- ── TABLE ACTIONS ROW (Pesquisa e Filtro de Cliente) ────── -->
  <div class="table-actions-row" [formGroup]="filtrosForm">
    <div class="search-box">
      <i class="ri-search-line"></i>
      <input type="text" formControlName="termoPesquisa" placeholder="Pesquisar factura, cliente ou NIF..." />
    </div>

    <div class="filters-group">
      <p-select formControlName="idCliente" [options]="clientes" optionLabel="nome" optionValue="id"
        placeholder="Todos clientes" [filter]="true" [showClear]="true" appendTo="body"
        [style]="{ minWidth: '220px' }" />

      <button type="button" class="btn-web-secondary icon-btn" title="Recarregar" [disabled]="loading"
        (click)="carregarDocumentos()">
        <i class="fas fa-rotate" [class.fa-spin]="loading"></i>
      </button>
    </div>
  </div>

  <!-- ── DATA TABLE WRAPPER (Padrão SecurPro — Tabela Clara) ─── -->
  <div class="data-table-wrapper">
    <!-- SKELETON ROWS -->
    <div *ngIf="loading" class="skeleton-rows">
      <p-skeleton height="48px" *ngFor="let i of [1, 2, 3, 4, 5]" styleClass="mb-2"></p-skeleton>
    </div>

    <!-- EMPTY STATE -->
    <app-empty-state *ngIf="!loading && documentos.length === 0" icon="ri-file-text-line"
      title="Nenhuma factura encontrada" message="Não há facturas para os filtros ou estado seleccionados."
      actionLabel="Emitir Factura" (action)="abrirWizardNovo()">
    </app-empty-state>

    <!-- DATA TABLE -->
    <table class="data-table" *ngIf="!loading && documentos.length > 0">
      <colgroup>
        <col style="width: 20%" />
        <col style="width: 32%" />
        <col style="width: 18%" />
        <col style="width: 14%" />
        <col style="width: 10%" />
        <col style="width: 60px" />
      </colgroup>
      <thead>
        <tr>
          <th>Nº FACTURA</th>
          <th>CLIENTE</th>
          <th class="text-right">VALOR (KZ)</th>
          <th>ESTADO AGT</th>
          <th>RECIBO</th>
          <th class="col-acoes text-right">ACÇÕES</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of documentos; trackBy: trackByDocId" class="clickable-row" (click)="abrirDetalhe(doc)">
          <!-- Nº FACTURA -->
          <td class="td-doc">
            <span class="doc-number">
              {{ doc.documentNo || '#' + doc.id }}
            </span>
            <span *ngIf="doc.seriesContingencyIndicator" class="contingency-tag" title="Emitida em modo contingência">
              CONTINGÊNCIA
            </span>
          </td>

          <!-- CLIENTE -->
          <td class="td-client">
            <div class="client-cell">
              <strong class="client-name">{{ clientName(doc) }}</strong>
              <div class="client-meta-line" *ngIf="clientNif(doc) || clientPhone(doc)">
                <small *ngIf="clientNif(doc)" class="client-nif">NIF: {{ clientNif(doc) }}</small>
                <small *ngIf="clientPhone(doc)" class="client-phone">
                  <i class="ri-phone-line"></i> {{ clientPhone(doc) }}
                </small>
              </div>
            </div>
          </td>

          <!-- VALOR (KZ) -->
          <td class="td-value text-right">
            <strong>{{ (doc.grossTotal || 0) | number: '1.2-2' }} Kz</strong>
          </td>

          <!-- ESTADO AGT -->
          <td class="td-status">
            <span class="status-badge" [ngClass]="statusBadgeClass(doc)">
              <span class="status-dot"></span>
              {{ statusLabel(doc) }}
            </span>
          </td>

          <!-- RECIBO -->
          <td class="td-receipt">
            <span class="recibo-badge" [ngClass]="reciboBadgeClass(doc)">
              {{ reciboLabel(doc) }}
            </span>
          </td>

          <!-- ACÇÕES: TRÊS PONTOS (Padrão SecurPro / Efetivos) -->
          <td class="col-acoes text-right" (click)="$event.stopPropagation()">
            <button type="button" class="btn-dots" title="Opções da factura" aria-label="Abrir opções da factura"
              (click)="openActions($event, doc, actionsMenu)">
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginação padronizada (Padrão Efetivos) -->
  <app-paginator-control *ngIf="!loading && totalRecords > 0" [alwaysShow]="true" [rows]="pageSize"
    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 15, 25, 50]" [first]="(currentPage - 1) * pageSize"
    (pageChange)="onPageChange($event)" />

  <!-- QUICK DRAWER -->
  <app-fatura-drawer [(visible)]="showDrawer" [modo]="drawerModo" [documentoOriginal]="drawerDocumento"
    (saved)="onDrawerSaved($event)" />
</div>